import React from "react";
import PropTypes from "prop-types";

const InlineLoader = ({
                          message = "Loading...",
                      }) =>
    <span>
        <img src="images/waiting.svg"
             alt={message}
             className="infinite-spin"
             style={{
                 display: "inline-block",
                 height: "1.5em",
                 marginRight: "0.5em",
             }}
        />
        {message}
    </span>;

InlineLoader.propTypes = {
    message: PropTypes.string,
};

export default InlineLoader;



// WEBPACK FOOTER //
// ./app/views/InlineLoader.js